import info from "./info";
import logline from "./logline";
import synopsis from "./synopsis";
import summary from "./summary";

import WritingPageNew from "../WritingPageNew";

const props = {
    title: info.title,
    type: info.type,
    bg: '40',
    link: '/charlie-mcbride-and-the-fourth-wall',
    logline: logline,
    synopsis: synopsis,
    summary: summary
}

export default WritingPageNew(props);
